<div class="row">
    <div class="col-lg-4 col-md-6 mx-auto col-xs-10 col-sm-10">
        <h2 class="titulo">RESULTADO</h2>
        <div class="row">
            <div class="col-lg-12 col-md-12">
                <div class="fondoItem">
                    <div class="contenedor">
                        <p class="resultado">{{ resultado }}</p>
                        <p class="numero"> {{ BMI }}</p>
                        <p class="interpretacion"> {{ interpretacion }}</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-12 col-md-12">
                <button routerLink="/" class="btn btn-primary btn-lg btn-color">RE-CALCULAR</button>
            </div>
        </div>
    </div>
</div>